import {Card, Col, Row} from 'antd';
import React, {useState} from 'react';
import {ListBase, ListProps, useListContext,} from 'react-admin';
import GridView from './GridView';
import ListView from './ListView';
import ServiceItemFilterPanel from "./SubComponents/ServiceItemFilterPanel";


const ServiceItemsListView = (props: ListProps) => {
    const { ids, data, loading, displayedFilters, filterValues, setFilters, page, total, perPage, setPage, setPerPage } = useListContext();
    const [viewMode, setViewMode] = useState<"grid"|"list">("grid");


    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
        >
            <Row>
                <Col span={5}>
                <div style={{ height: '100%', borderRight: '1px solid #f0f0f0', padding: '16px' }}>
                    <ServiceItemFilterPanel filterValues={filterValues} setFilters={setFilters} viewMode={viewMode} setViewMode={setViewMode} />
                </div>
                </Col>
                <Col style={{overflowX: 'auto'}} span={19}>
                {
                    viewMode==="list"?
                        <ListView />
                        :
                        <GridView />
                }
                </Col>
            </Row>

    </Card>
  )
}

const ServiceItemsList = (props: ListProps) => {
    return (
        <ListBase
            sort={{ field: 'id', order: 'DESC' }}
            filter={{light: true}}
            perPage={25}
            {...props}
        >
            <ServiceItemsListView />
        </ListBase>
    )
}

export default ServiceItemsList;
